import React from 'react';
import { BaasicModal, ErrorView } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
	},
};

function BaasicErrorModalTemplate({ modalParams }) {
	return (
		<BaasicModal modalParams={modalParams} style={customStyles}>
			<ErrorView message={modalParams.message} onClose={modalParams.onClose} />
		</BaasicModal>
	);
}

export default defaultTemplate(BaasicErrorModalTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/dialog/BaasicErrorModalTemplate.jsx